import { Button } from "@components/ui/Button"
import { Icon } from "@components/ui/Icon"
import { cn } from "@utils/tw"
import { defineBlock, EditableText } from "eddev/blocks"
import { Link } from "eddev/routing"

export const meta: BlockMeta = {
  title: "Featured Card Button",
  icon: "forms",
}

export default defineBlock("content/featured-card-button", (props) => {
  const link = props.link

  const button = (
    <Link
      href={link?.url}
      target={link?.target}
      className={cn(
        "bg-transparent justify-between flex items-center gap-2 type-ui-m py-[0.3em] transition-colors pl-[0.7em] -ml-[0.7em] pr-[0.6em] -mr-[0.6em] hover:bg-fg/10 active:bg-fg/20 text-fg rounded-[12px]",
      )}
    >
      <span>{props.link?.title || "Button"}</span>
      <Icon name="chevronRight" />
    </Link>
  )

  return button
})
